import type { LevelResult, TestState } from '../types/index.ts';
import { calcVO2Max } from './scoring.ts';
import { CLINIC_PROTOCOL_VERSION, clinicScoreForProtocol, clinicRegressionForProtocol, stageCostsForProtocol, ORSTED_CLINIC_PROTOCOL_VERSION } from '../../supabase/functions/_shared/clinic-protocol.ts';

export const CONSUMER_PROTOCOL_VERSION = CLINIC_PROTOCOL_VERSION;

/** New runs are explicitly versioned; untagged in-memory historical inputs retain their original model. */
export function consumerScore(state: Pick<TestState, 'protocolVersion' | 'data' | 'maxHR'>): number {
  if (state.protocolVersion === CONSUMER_PROTOCOL_VERSION || state.protocolVersion === ORSTED_CLINIC_PROTOCOL_VERSION) {
    const costs = stageCostsForProtocol(state.protocolVersion);
    if (state.data.length < 3 || state.data.length > 5 || state.data.some((reading, index) =>
      reading.level !== index + 1 || reading.vo2Estimate !== costs[index] || !Number.isInteger(reading.hr) || reading.hr < 40 || reading.hr > 230 ||
      !Number.isInteger(reading.rpe) || reading.rpe < 0 || reading.rpe > 10
    )) return NaN;
    if (state.data.slice(0, -1).some(reading => reading.rpe >= 8 || reading.hr >= state.maxHR * 0.8)) return NaN;
    return clinicScoreForProtocol(state.protocolVersion, state.data, state.maxHR);
  }
  if (state.protocolVersion) return NaN;
  return calcVO2Max(state.data, state.maxHR);
}

export function currentConsumerRegression(data: LevelResult[]) {
  return clinicRegressionForProtocol(CLINIC_PROTOCOL_VERSION, data);
}

export function isCurrentConsumerProtocol(state: Pick<TestState, 'protocolVersion'>): boolean {
  return state.protocolVersion === CONSUMER_PROTOCOL_VERSION || state.protocolVersion === ORSTED_CLINIC_PROTOCOL_VERSION;
}
